// 主题配置
const themeConfig = {
  // 默认主题
  default: {
    name: '默认',
    colors: {
      '--primary-color': '#202630',      // 主色
      '--secondary-color': '#4CD964',   // 副色
      '--background-color': '#181a20',   // 背景色
      '--text-color': '#EAECEF',         // 文字色
      '--border-color': '#EEEEEE',       // 边框色
      '--disabled-color': '#CCCCCC'      ,// 禁用色
	  '--ban-color': '#FCD535',       // 按钮颜色
	  '--ban-color2': '#333b47',       // 按钮颜色
    }
  },
  // 暗黑主题
  dark: {
    name: '暗黑',
    colors: {
      '--primary-color': '#0A84FF',
      '--secondary-color': '#30D158',
      '--background-color': '#1C1C1E',
      '--text-color': '#FFFFFF',
      '--border-color': '#333333',
      '--disabled-color': '#555555'
    }
  },
  // 商务蓝
  business: {
    name: '商务蓝',
    colors: {
      '--primary-color': '#2196F3',
      '--secondary-color': '#03A9F4',
      '--background-color': '#F5F9FF',
      '--text-color': '#333333',
      '--border-color': '#E0E0E0',
      '--disabled-color': '#BBDEFB'
    }
  },
  // 活力橙
  vibrant: {
    name: '活力橙',
    colors: {
      '--primary-color': '#FF9500',
      '--secondary-color': '#FF7043',
      '--background-color': '#FFF8F0',
      '--text-color': '#333333',
      '--border-color': '#FFE0B2',
      '--disabled-color': '#FFCC80'
    }
  }
}

/**
 * 获取所有主题列表
 */
export function getThemeList() {
  return Object.keys(themeConfig).map(key => ({
    id: key,
    name: themeConfig[key].name,
    colors: themeConfig[key].colors
  }))
}

/**
 * 获取当前主题
 */
export function getCurrentTheme() {
  // 从本地存储获取，没有则返回默认主题
  const themeId =  'default'
  return {
    id: themeId,
    ...themeConfig[themeId]
  }
}

/**
 * 设置主题
 * @param {string} themeId 主题ID
 */
export function setTheme(themeId) {
  if (!themeConfig[themeId]) {
    console.error(`主题 ${themeId} 不存在`)
    return false
  }
  
  // 1. 保存到本地存储
  uni.setStorageSync('theme', themeId)
  
  // 2. 应用到页面
  applyTheme(themeConfig[themeId].colors)
  
  // 3. 触发全局主题变更事件
  uni.$emit('themeChange', themeId)
  
  return true
}

/**
 * 应用主题样式到页面
 * @param {object} colors 颜色键值对
 */
function applyTheme(colors) {
  // 创建或更新样式元素
  let styleElement = document.getElementById('dynamic-theme')
  if (!styleElement) {
    styleElement = document.createElement('style')
    styleElement.id = 'dynamic-theme'
    document.head.appendChild(styleElement)
  }
  
  // 生成CSS变量定义
  let cssText = ':root {'
  for (const [key, value] of Object.entries(colors)) {
    cssText += `${key}: ${value};`
  }
  cssText += '}'
  
  styleElement.innerHTML = cssText
}

/**
 * 初始化主题
 */
export function initTheme() {
	
  const theme = getCurrentTheme()
  applyTheme(theme.colors)
}

// 默认导出主题管理方法
export default {
  getThemeList,
  getCurrentTheme,
  setTheme,
  initTheme
}